module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPBJREFUeNrk2t0NwjAMRtGYCToKKzA5I9BR2CAEqX0A+heIk3wXS1afj9Q2ju0QnCPGODwzKMeEuE05qCPm0MMsIPQwGwgdzAFE/5gMRL+YLxD9YX5A9IMpgGiPKYhoh3FA1Mc4IuphKiD8MRURfpgGiPKYhogsjO0h0uOa8tz43B1TXszsng3pCHEIYyKIXYwJITYxJoZYxZggYhFjoogPjAkjXjCnAAnOq4X62FG/X9SBiCpRUEWjYhmPuVj9z1UX1XxAtYNQDTpUyxTVxHbAIGYkiKkVYo6ImOwiZu2I7QfEPgpiQ0gX8YZxRzwEGACUB5Sa3renRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/delay-map/White-Unknown.png
// module id = 623
// module chunks = 1